import { CostCentersAssignmentsWithCostCenterCountDocument } from 'generated/resources/graphql'
import { orderBy } from 'lodash'
import moment from 'moment'

import { useQuery } from 'modules/core/hooks/useQuery'

interface Props {
  resourceId: number
  resourceType: string
}

const useCurrentCostCentersAssignments = ({ resourceId, resourceType }: Props) => {
  const { data, loading, refetch } = useQuery(CostCentersAssignmentsWithCostCenterCountDocument, {
    variables: {
      resourceId,
      resourceType,
      applyingOn: moment().format('YYYY-MM-DD'),
    },
  })

  const hasCostCenters = (data?.costCenters.costCentersConnection?.totalCount || 0) > 0

  const assignments =
    orderBy(data?.costCenters.assignmentsConnection.nodes, 'startDate', 'desc') || []

  return {
    isLoading: loading,
    assignments,
    hasCostCenters,
    refetch,
  }
}

export default useCurrentCostCentersAssignments
